import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enLang from "./locales/en.json";
import arLang from "./locales/ar.json";

const resources = {
    en: enLang,
    ar: arLang
};

i18n
    .use(LanguageDetector) // لاكتشاف لغة المتصفح تلقائياً
    .use(initReactI18next) // لربط i18next بـ React
    .init({
        resources,
        fallbackLng: "en", // اللغة الافتراضية
        interpolation: {
            escapeValue: false // React بيحمي نفسه من XSS
        }
    });

export default i18n;